"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceRequestPosition = void 0;
const typeorm_1 = require("typeorm");
const RequestPosition_1 = require("./RequestPosition");
const ServiceClass_1 = require("../../service/entity/ServiceClass");
let ServiceRequestPosition = class ServiceRequestPosition extends RequestPosition_1.RequestPosition {
    constructor(init) {
        super();
        if (init) {
            Object.assign(this, init);
        }
    }
};
exports.ServiceRequestPosition = ServiceRequestPosition;
__decorate([
    (0, typeorm_1.ManyToOne)(() => ServiceClass_1.ServiceClass),
    __metadata("design:type", ServiceClass_1.ServiceClass)
], ServiceRequestPosition.prototype, "serviceClass", void 0);
__decorate([
    (0, typeorm_1.RelationId)((sc) => sc.serviceClass),
    __metadata("design:type", String)
], ServiceRequestPosition.prototype, "serviceClassId", void 0);
__decorate([
    (0, typeorm_1.Column)({ type: 'jsonb', nullable: true }),
    __metadata("design:type", Object)
], ServiceRequestPosition.prototype, "languages", void 0);
exports.ServiceRequestPosition = ServiceRequestPosition = __decorate([
    (0, typeorm_1.ChildEntity)('service-position'),
    __metadata("design:paramtypes", [Object])
], ServiceRequestPosition);
